import type { Tool } from './types';

export const cards = [
  {
    logo: require('./images/logos/webflow-logo.svg'),
    company: 'Webflow',
    position: 'Enterprise Account Executive',
  },
  {
    logo: require('./images/logos/craft-logo.svg'),
    company: 'Craft',
    position: 'Sales Development Representative',
    hideOnMobile: true,
  },
  {
    logo: require('./images/logos/fireheadz-logo.svg'),
    company: 'Fireheadz',
    position: 'Sales Development Representative',
  },
  {
    logo: require('./images/logos/ripplematch-logo.svg'),
    company: 'RippleMatch',
    position: 'Sales Development Representative',
  },
  {
    logo: require('./images/logos/smartsheet-logo.svg'),
    company: 'Smartsheet',
    position: 'Enterprise Account Executive',
  },
  {
    logo: require('./images/logos/lumos-logo.svg'),
    company: 'Lumos',
    position: 'Enterprise Account Executive',
  },
];

export const profits = [
  {
    icon: require('./images/icons/money-icon.svg'),
    title: 'Attainable quota and OTE',
    animation: 'fade-right',
  },
  {
    icon: require('./images/icons/lightning-icon.svg'),
    title: 'Growth opportunities',
    animation: 'fade-up',
  },
  {
    icon: require('./images/icons/atom-icon.svg'),
    title: 'Excellent sales training and support',
    animation: 'fade-up',
  },
  {
    icon: require('./images/icons/users-icon.svg'),
    title: 'Outstanding sales culture',
    animation: 'fade-left',
  },
];

export const tools: Tool[] = [
  {
    animation: 'fade-right',
    icon: require('./images/icons/user-icon.svg'),
    title: 'Jobs',
    subtitle: 'Get matched with fast-growing, vetted employers',
    event: 'product__jobs__cta-button__click',
    link: {
      url: 'https://jobs.bravado.co/',
      text: 'Open roles',
      external: true,
    },
  },
  {
    animation: 'fade-up',
    icon: require('./images/icons/chat-icon.svg'),
    title: 'War Room',
    subtitle: 'Get advice from top sales professionals',
    event: 'product__war-room__cta-button__click',
    link: {
      url: '/war-room/posts/tab/my_feed?dynamic_modal=sign-up',
      text: 'Enter forum',
      external: true,
    },
  },
  {
    animation: 'fade-up',
    icon: require('./images/icons/portfolio-icon.svg'),
    title: 'Seller Portfolio',
    subtitle: 'Build trust with customers + close more deals',
    event: 'product__seller-portfolio__cta-button__click',
    link: {
      url: 'https://portfolio.bravado.co/',
      text: 'See my portfolio',
      external: true,
    },
  },
  {
    animation: 'fade-left',
    icon: require('./images/icons/hat-icon.svg'),
    title: 'Bravado Academy',
    subtitle: 'Tactical sales advice to help you become a #1',
    event: 'product__academy__cta-button__click',
    link: {
      url: '/academy/category/all-articles ',
      text: 'See articles',
      external: true,
    },
  },
];

export const articles = [
  {
    image: require('~/components/partials/landings/main-page/images/articles/1.webp'),
    title: 'Job search',
    text: 'Learn how to carve out opportunities, build a stellar network, and map out your next career move in sales.',
    link: '/academy/sales-job-search',
    position: 'position1',
    badge: '',
  },
  {
    image: require('~/components/partials/landings/main-page/images/articles/2.webp'),
    title: 'Interviewing',
    text: 'A step-by-step guide to mastering your next sales interview and confidently landing the job you want.',
    link: '/academy/sales-interviewing',
    position: 'position2',
    badge: '',
  },
  {
    image: require('~/components/partials/landings/main-page/images/articles/3.webp'),
    title: 'Starting a New Job',
    text: 'Landed an amazing new job? Congrats! Read on for some of the best on-the-job advice to fight the jitters and set yourself up for success from day 1.',
    link: '/academy/starting-new-job-in-sales',
    position: 'position3',
    badge: '',
  },
  {
    image: require('~/components/partials/landings/main-page/images/articles/4.webp'),
    title: 'How to get into Tech Sales',
    text: 'If you’re already in sales and thinking of making the leap into tech, this one is for you.',
    link: '/academy/breaking-into-tech-sales',
    position: 'position4',
    badge: '',
  },
  {
    image: require('~/components/partials/landings/main-page/images/articles/5.webp'),
    title: 'Cold Emails',
    text: 'One cold email can win the game. Discover the best cold email strategies and access templates that prospects can connect to.',
    link: '/academy/ultimate-guide-to-outbound-prospecting',
    position: 'position5',
    badge: 'New',
  },
  {
    image: require('~/components/partials/landings/main-page/images/articles/6.webp'),
    title: 'Discovery & Demos',
    text: 'Learn how to identify the right opportunity, structure your initial sales pitch, and modify your message to connect with any audience.',
    link: '/academy/sales-discovery-and-needs-analysis',
    position: 'position6',
    badge: 'Updated',
  },
];

export const testimonials = [
  {
    name: 'MG',
    initials: 'MG',
    color: 'pink',
    location: 'United States',
    title: "Highly recommend if you're looking for a job in customer success!",
    text: "Bravado introduced me to 3 really interesting companies I wouldn't have found myself. The team prepped me for interviews and gave me some helpful tips for interviewing. I landed a job at one of 3 and I LOVE it here!",
  },
  {
    name: 'Delvis Perez',
    initials: 'DP',
    color: 'green1',
    location: 'United States',
    title: 'Bravado is the Future',
    text: 'From start to finish, I felt as if I had Bravado in my corner. They made the recruitment process extremely easy, gave me a confidence boost when I needed it most, and instilled the confidence needed to counteroffer. Rebecca is an absolute rockstar and did a fantastic job of keeping me informed and prepped for the next step. In the end, I landed my dream role at a world class company and negotiated a massive pay raise! THANK YOU BRAVADO!',
  },
  {
    name: 'Conor Chepenik',
    initials: 'CC',
    color: 'gray',
    location: 'California',
    title: 'Chep’s Review',
    text: 'This site is a gold mine of sales individuals eager to laugh and learn from each other🤝',
  },
  {
    name: 'Mustafa Salihbegović',
    initials: 'MS',
    color: 'green2',
    location: 'United States',
    title: 'Bravado was the best resource I have…',
    text: 'Bravado was the best resource I have used in a long time! Super easy process and every company that reached out to me was solid and exactly what I was looking for. I accepted a position with a employer that I’m super excited about and will refer anyone I know to use bravado! Thanks again!',
  },
  {
    name: 'Jashandeep Mundi',
    initials: 'JM',
    color: 'yellow1',
    location: 'California',
    title: 'Bravado Is One Of The Best Platform To Be On As A Sales Rep',
    text: "Bravado was instrumental in helping me find my new BDR role at Commsor. Ryan guided me throughout the entire process and the end result was an amazing offer from an amazing startup. It's exciting times!",
  },
  {
    name: 'Heyley Pogue',
    initials: 'HP',
    color: 'violet',
    location: 'United States',
    title: 'Bravado changed the trajectory of my life',
    text: "Bravado helped me find a better job where I can learn and grow! Bravado's CEO, Sahil, reached out to me directly when I signed up for the site and he made it his mission to help me find a place I wanted to work. I was underpaid and over-performing at my then-role. He personally reached out to companies and made introductions and helped me land where I am today. I am thriving in my new role at a rocketship of a company. Bravado honestly changed my life",
  },
  {
    name: 'Mark Kunzman',
    initials: 'MK',
    color: 'yellow2',
    location: 'United States',
    title: 'Finding a job can be a very stressful…',
    text: "Finding a job can be a very stressful endeavor, and you often feel like you're banging your head against a wall repeatedly, trying to get interviews with decision makers. Having Bravado on my side changed everything. With very professional and personable employees like Hayley Weik working as an advocate on my behalf, I not only began to get interviews soon after signing up for Bravado, but I received a great job offer from an amazing company within two weeks of interviewing with them. I wouldn't have gotten the interview in the first place had it not been for Hayley. Thank you Hayley, and thank you Bravado!",
  },
  {
    name: 'Mohammed',
    initials: 'M',
    color: 'green3',
    location: 'California',
    title: 'The best sales professional community',
    text: 'I’ve been a member of Bravado’s War Room for 6 months now and it addresses such a huge gap for sales professionals. The community offers a forum to ask questions about everything from prospecting and closing, to career progression and work life balance. I also worked with Bravado Jobs, which unlocked opportunities for me that I didn’t know existed. ',
  },
];

export const saasCompanies = {
  LinkedIn: require('./images/logos/linkedin-logo.svg'),
  Salesforce: require('./images/logos/salesforce-logo.svg'),
  Amazon: require('./images/logos/amazon-logo.svg'),
  Uber: require('./images/logos/uber-logo.svg'),
  Google: require('./images/logos/google-logo.svg'),
  Slack: require('./images/logos/slack-logo.svg'),
  Twilio: require('./images/logos/twilio-logo.svg'),
  Zoom: require('./images/logos/zoom-logo.svg'),
  Wix: require('./images/logos/wix-logo.svg'),
  Adobe: require('./images/logos/adobe-logo.svg'),
  FIX_ME1: require('./images/logos/FIX_ME1.svg'),
  Gong: require('./images/logos/gong-logo.svg'),
  Cloudera: require('./images/logos/cloudera-logo.svg'),
  FIX_ME2: require('./images/logos/FIX_ME2.svg'),
  Sap: require('./images/logos/sap-logo.svg'),
};
